import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  Stack,
  Input,
  TextField,
  InputAdornment,
  Link,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import { handleSpringDataMutationRequest } from "../../utils/apiUtils";
import EmailIcon from "@mui/icons-material/Email";
import CheckIcon from "@mui/icons-material/Check";
import { toast } from "react-toastify";

export default function Onboarding() {
  const [file, setFile] = useState(null);
  const [email, setEmail] = useState("");
  const [validatedProperties, setValidatedProperties] = useState([]);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [validationProgress, setValidationProgress] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(false);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];

    if (selectedFile && selectedFile.name.endsWith(".xlsx")) {
      const reader = new FileReader();

      reader.onload = () => {
        const base64String = reader.result.split(",")[1]; // strip metadata prefix
        console.log("Base64 XLS:", base64String, selectedFile);
        setFile({
          raw: selectedFile,
          base64: base64String,
        });
      };

      reader.readAsDataURL(selectedFile); // converts file to base64
    } else {
      alert("Please upload a valid .xls file");
      setFile(null);
    }
  };

  const handleValidate = () => {
    if (!file) {
      toast.error("Please attach a file first.");
      return;
    }
    setValidationProgress(true);
    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/xls-onboarding/validate?emailId=${email}&fileName=${file?.raw?.name}`,
      file?.base64
    )
      .then((res) => {
        setValidationProgress(false);
        setValidatedProperties(res);
        if (res.length > 0) {
          setOpenAlert(true);
          setAlertMessage("Properties validated successfully!");
          // setTimeout(() => {
          //   setOpenAlert(false);
          //   setAlertMessage("");
          // }, 3000);
        }
      })
      .catch(() => {
        setValidationProgress(false);
        setValidatedProperties([]);
      });
  };

  const handleUpload = () => {
    if (!file) {
      toast.error("Please attach a file first.");
      return;
    }
    setUploadProgress(true);
    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/xls-onboarding/onboard?emailId=${email}&fileName=${file?.raw?.name}`,
      file?.base64
    )
      .then((res) => {
        setUploadProgress(false);
        setOpenAlert(true);
        setAlertMessage("Properties onboarded successfully!");
        setValidatedProperties([]);
        setEmail("");
        setFile(null);
        setTimeout(() => {
          setOpenAlert(false);
          setAlertMessage("");
        }, 10000);
      })
      .catch(() => {
        setUploadProgress(false);
      });
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography sx={{ fontSize: "1.5rem" }}>Bulk onboarding</Typography>
      <Paper
        elevation={3}
        sx={{
          maxWidth: 600,
          mx: "auto",
          mt: 5,
          p: 3,
          textAlign: "center",
        }}
      >
        {openAlert && (
          <Alert
            severity="success"
            icon={<CheckIcon fontSize="inherit" />}
            sx={{ mb: 2 }}
          >
            {alertMessage}
          </Alert>
        )}
        <Typography variant="h6" gutterBottom>
          Upload Excel File
        </Typography>

        <TextField
          label="Email"
          type="email"
          variant="outlined"
          fullWidth
          sx={{ marginY: 3 }}
          size="small"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={validatedProperties.length > 0}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EmailIcon />
              </InputAdornment>
            ),
          }}
        />

        <Box>
          <Input
            type="file"
            inputProps={{ accept: ".xlsx" }}
            onChange={handleFileChange}
            disabled={validatedProperties.length > 0}
          />
        </Box>

        <Link
          href="https://docs.google.com/spreadsheets/d/1yXJqPleLdXyNoQLeN4bmg-BYd0b6GTrHV7uiCFgKV_o/export?format=xlsx"
          download
          sx={{ mt: 2, display: "block" }}
        >
          Download template here
        </Link>

        <Stack
          direction="row"
          spacing={2}
          justifyContent="space-between"
          sx={{ mt: 3 }}
        >
          <Button
            variant="outlined"
            color="primary"
            onClick={handleValidate}
            disabled={validationProgress}
            sx={{ textTransform: "none" }}
          >
            Validate {validationProgress && <CircularProgress size={16} />}
          </Button>
          <Button
            variant="custom-button"
            color="success"
            onClick={handleUpload}
            disabled={validatedProperties.length < 1 || uploadProgress}
          >
            Upload {uploadProgress && <CircularProgress size={16} />}
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
